<template>
<div class="align-self-center speed-up">
    <button @click="toggleSpeed()">
        <span v-if="!speed"><fa-icon icon="fast-forward"></fa-icon></span>
        <span v-else><fa-icon icon="fast-backward"></fa-icon></span>
    </button>
</div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
    methods: {
        ...mapMutations(['toggleSpeed']),
    },
    computed: {
        speed() {
            return this.$store.state.speed;
        }
    }
}
</script>